$(document).ready(function () {
  "use strict";
  // navbar js start ---
let lastScroll = 0;

window.addEventListener("load", handleScroll);
window.addEventListener("scroll", handleScroll);

function handleScroll() {
  const scrolling = window.scrollY;
  const navbar = document.querySelector(".navbar");

  if (scrolling > 10) {
    navbar.classList.add("nav-fixed");
  } else {
    navbar.classList.remove("nav-fixed", "nav-hidden");
  }

  if (scrolling > lastScroll && scrolling > 80) {
    // scrolling down — hide header
    navbar.classList.add("nav-hidden");
  } else if (scrolling < lastScroll) {
    // scrolling up — show header
    navbar.classList.remove("nav-hidden");
  }

  lastScroll = scrolling;
}

  function openMobileMenu() {
    $(".navbar-links-wrapper").addClass("active");
    $(".ham-menu").addClass("active");
    $(".navbar-links-inner").addClass("active");
    $("body").addClass("active");
  }

  function closeMobileMenu() {
    $(".navbar-links-wrapper").removeClass("active");
    $(".ham-menu").removeClass("active");
    $(".navbar-links-inner").removeClass("active");
    $("body").removeClass("active");
  }

  $(document).on("click", ".navbar-left > .mobile-menu-btn", function (event) {
    event.stopPropagation();
    openMobileMenu();
  });

  $(document).on("click", ".nav-sidebar-top .mobile-menu-btn", function (event) {
    event.stopPropagation();
    closeMobileMenu();
  });

  $(".mobile-menu-close-window-btn").click(function (event) {
    event.stopPropagation();
    closeMobileMenu();
  });

  $(".navbar-links-wrapper").click(function (event) {
    if ($(event.target).is(".navbar-links-wrapper")) {
      closeMobileMenu();
    }
  });

  // mobile-dropdown responsive accordion js start--
  $(function () {
    let isMobile = window.matchMedia(
      "only screen and (max-width: 992px)"
    ).matches;

    if (isMobile) {
      // **..mobile-dropdown-accordion js start..**
      $(".navbar-megamenu-content").slideUp();
      $(".navbar-link.has-megamenu > .navbar-link-title").on("click", function (event) {
        event.preventDefault();
        event.stopPropagation();

        const parentItem = $(this).parent();
        const megaContent = $(this).next(".navbar-megamenu-content");

        megaContent.stop(true, true).slideToggle(220);
        parentItem.toggleClass("active");
        $(this)
          .parent()
          .siblings()
          .removeClass("active")
          .find(".navbar-megamenu-content")
          .stop(true, true)
          .slideUp(220);
      });
      // **..mobile-dropdown-accordion js end..**
    }

    // mobile-dropdown responsive accordion js start--
    $(function () {
      let isMobile = window.matchMedia(
        "only screen and (max-width: 992px)"
      ).matches;

      if (isMobile) {
        $(".dropdown-sub-menu").slideUp();
        // **..mobile-dropdown-accordion js start..**
        $(".dropdown-btn1").on("click", function () {
          $(this).next(".dropdown-sub-menu1").slideToggle();
          $(this).toggleClass("active");
        });
        // **..mobile-dropdown-accordion js end..**

        // **..mobile-dropdown-accordion js start..**
        $(".dropdown-btn2").on("click", function () {
          $(this).next(".dropdown-sub-menu2").slideToggle();
          $(this).toggleClass("active");
        });
        // **..mobile-dropdown-accordion js end..**
      }
    });
    // mobile-dropdown responsive accordion js end--
  });
  // mobile-dropdown responsive accordion js end--

  $(".search-bar-open-btn").click(function (event) {
    event.stopPropagation();
    if ($(".search-bar-overlay").hasClass("active")) {
      $(".search-bar-overlay").removeClass("active");
      $(".search-bar-close-window-btn").removeClass("active");
      $("body").removeClass("active");
      $(".navbar").removeClass("search-active");
    } else {
      $(".search-bar-overlay").addClass("active");
      $(".search-bar-close-window-btn").addClass("active");
      $("body").addClass("active");
      $(".navbar").addClass("search-active");
    }
  });

  $(".search-bar-close-window-btn").click(function (event) {
    event.stopPropagation();
    $(".search-bar-overlay").removeClass("active");
    $(this).removeClass("active");
    $("body").removeClass("active");
    $(".navbar").removeClass("search-active");
  });

  $(".search-close-btn").click(function (event) {
    event.stopPropagation();
    $(".search-bar-overlay").removeClass("active");
    $(".search-bar-close-window-btn").removeClass("active");
    $("body").removeClass("active");
    $(".navbar").removeClass("search-active");
  });

  // navbar js end ---

  // hero-animation scroll-driven js start---
  (function () {
    var heroWrapper  = document.querySelector('.hero-scroll-wrapper');
    var heroSection  = document.querySelector('.hero-slider-section');
    var navbar       = document.querySelector('.navbar');

    if (!heroWrapper || !heroSection || !navbar) return;

    function updateHeroAnimation() {
      var scrolled           = window.scrollY;
      var wrapperHeight      = heroWrapper.offsetHeight;        // ~200vh in px
      var sectionHeight      = window.innerHeight;              // ~100vh in px
      var scrollableDistance = wrapperHeight - sectionHeight;   // ~100vh in px

      // progress: 0 at top of page → 1 when hero wrapper fully scrolled past
      var progress = Math.max(0, Math.min(1, scrolled / scrollableDistance));

      if (progress < 0.5) {
        // green / initial pinned state
        heroSection.classList.add('green');
        navbar.classList.add('green', 'hover-green');
        $('.hero-animation-btn').addClass('active');
      } else {
        // dark image / normal state
        heroSection.classList.remove('green');
        navbar.classList.remove('green', 'hover-green');
        $('.hero-animation-btn').removeClass('active');
      }
    }

    // Set correct state immediately on load
    updateHeroAnimation();

    window.addEventListener('scroll', updateHeroAnimation, { passive: true });
    window.addEventListener('resize', updateHeroAnimation, { passive: true });
  })();

  $(".navbar").on("mouseenter", function () {
    if ($(this).hasClass("hover-green")) {
      $(this).addClass("green");
    }
  });

  $(".navbar").on("mouseleave", function () {
    if ($(this).hasClass("hover-green")) {
      $(this).addClass("green");
    }
  });

  // hero-animation scroll-driven js end---

  // video review popup js start---
  $(".video-review-content").click(function (event) {
    event.stopPropagation();
    $(".video-review-popup").addClass("active");
  });

  $(".video-review-popup-close").click(function (event) {
    event.stopPropagation();
    $(".video-review-popup").removeClass("active");
  });
  // video review popup js end---

    $(".footer-select-field-heading").click(function (event) {
    event.stopPropagation();
    $(this).parent().toggleClass("active");
  });

  // close currency dropdown when clicking anywhere outside it
  $(document).click(function () {
    $(".footer-select-field-item").removeClass("active");
  });
});
// testimonial-video-play-function
const sections = document.querySelectorAll(".testimonial-item");

sections.forEach((section) => {
  let x = section.querySelector(".testimonial-video");
  let btn = section.querySelector(".video-play-btn");
  let authorInfo = section.querySelector(".testimonial-author");
  
  if (authorInfo) {
    authorInfo.style.transition = "opacity 0.3s ease, visibility 0.3s ease";
  }

  if (btn && x) {
    btn.addEventListener("click", toggleVideo);
    function toggleVideo() {
      let playIcon = btn.querySelector(".play-icon");
      let pauseIcon = btn.querySelector(".pause-icon");
      if (x.paused) {
        x.play();
        playIcon.style.display = "none";
        pauseIcon.style.display = "block";
        if (authorInfo) {
          authorInfo.style.opacity = "0";
          authorInfo.style.visibility = "hidden";
        }
      } else {
        x.pause();
        playIcon.style.display = "block";
        pauseIcon.style.display = "none";
        if (authorInfo) {
          authorInfo.style.opacity = "1";
          authorInfo.style.visibility = "visible";
        }
      }
    }
  }
});

// testimonial-slider js start--
const marqueeTestimonial = document.querySelector(".testimonial-slider");
if (marqueeTestimonial) {
  const desktopGap = parseInt(marqueeTestimonial.dataset.gapDesktop) || 48;
  const mobileGap = parseInt(marqueeTestimonial.dataset.gapMobile) || 20;

  const testimonialSlider = new Swiper(".testimonial-slider", {
    spaceBetween: desktopGap,
    centeredSlides: true,
    speed: 9000,
    freeMode: true,
    freeModeMomentum: false,
    autoplay: {
      delay: 0,
      disableOnInteraction: false,
    },
    loop: true,
    slidesPerView: "auto",
    allowTouchMove: true,
    breakpoints: {
      1: { spaceBetween: mobileGap },
      576: { spaceBetween: mobileGap },
      768: { spaceBetween: 24 },
      993: { spaceBetween: desktopGap },
    },
  });

  // Click anywhere on the slider to toggle play/pause
  marqueeTestimonial.addEventListener("click", (e) => {
    // Don't toggle if clicking the play button
    if (e.target.closest('.video-play-btn')) return;

    // Delay slightly so Swiper's internal touch handlers don't conflict
    setTimeout(() => {
      if (testimonialSlider.autoplay.running) {
        testimonialSlider.autoplay.stop();
        marqueeTestimonial.dataset.userPaused = "true";
      } else {
        testimonialSlider.autoplay.start();
        marqueeTestimonial.dataset.userPaused = "false";
      }
    }, 50);
  });

  // Pause on hover testimonial slider js
  marqueeTestimonial.addEventListener("mouseenter", () => {
    if (testimonialSlider.autoplay.running) {
      testimonialSlider.autoplay.stop();
    }
  });

  marqueeTestimonial.addEventListener("mouseleave", () => {
    if (marqueeTestimonial.dataset.userPaused !== "true") {
      testimonialSlider.autoplay.start();
    }
  });
}
// testimonial-slider js end--

// newsletter type js start---
let newsletterSections = document.querySelectorAll(".newsletter-section");
newsletterSections.forEach((section) => {
  let newsletter_input = section.querySelector(".newsletter_input");
  const news_submit_btn = section.querySelector(".news_submit_btn");
  const newsletter_form = section.querySelector("form");
  const newsletter_checkbox = section.querySelector("input[name='contact[newsletter_consent]']");
  const terms_error_msg = section.querySelector(".terms-error-msg");

  newsletter_input?.addEventListener("input", () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (emailRegex.test(newsletter_input.value.trim())) {
      news_submit_btn.disabled = false;
    } else {
      news_submit_btn.disabled = true;
    }
  });

  if (newsletter_form && newsletter_checkbox && terms_error_msg) {
    // Intercept click on the submit button
    if (news_submit_btn) {
      news_submit_btn.addEventListener("click", (e) => {
        if (!newsletter_checkbox.checked) {
          e.preventDefault();
          terms_error_msg.style.display = "block";
        }
      });
    }

    newsletter_form.addEventListener("submit", (e) => {
      if (!newsletter_checkbox.checked) {
        e.preventDefault();
        e.stopImmediatePropagation();
        terms_error_msg.style.display = "block";
      } else {
        terms_error_msg.style.display = "none";
      }
    });

    newsletter_checkbox.addEventListener("change", () => {
      if (newsletter_checkbox.checked) {
        terms_error_msg.style.display = "none";
      }
    });
  }
});
// newsletter type js end---

$(document).ready(function(){
  // Keep megamenu open and siblings faded when moving across navbar links
  $('.navbar-link').on('mouseenter', function(){
    // First remove from all
    $('.navbar-link').removeClass('show-megamenu active');
    
    // Then apply to hovered if it has megamenu
    if($(this).hasClass('has-megamenu')) {
      $(this).addClass('show-megamenu');
      $(this).siblings().addClass('active');
    }
  });

  $('.navbar-links').on('mouseleave', function(){
    $('.navbar-link').removeClass('show-megamenu active');
  });


  $('.currency_input').on('click', function(){
      var c = $(this).val();
      $('#currency_iso_code').val(c);
      $('#country_form').submit();
  })
    
})
